import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { Splash } from '@/components/ui/Splash';
import { subscriptionApis } from '@/features/subscription';
import { CheckoutPlanEnum } from '@/features/subscription/subscription.types';

const CheckoutSplash = () => <Splash reason="upgrade-checkout" />;

export const Route = createFileRoute('/upgrade')({
  staticData: { requiresAuth: true },
  validateSearch: z.object({
    plan: CheckoutPlanEnum.optional().catch(undefined),
  }),
  beforeLoad: async ({ context, location }) => {
    await context.auth.requireAuth(location);
  },
  loaderDeps: ({ search }) => ({ plan: search.plan }),
  async loader({ deps }) {
    await subscriptionApis.startPlanCheckout(deps.plan, 'home');
    throw redirect({
      to: '/chats',
      hash: 'settings/Subscription',
      replace: true,
    });
  },
  component: CheckoutSplash,
  pendingComponent: CheckoutSplash,
  pendingMs: 0,
});
